// extracted by mini-css-extract-plugin
export default {"tableContainer":"InvoiceParterList_tableContainer__o55Gz"};